import { Component, ViewContainerRef, HostListener, Inject, OnInit } from '@angular/core';
import { AppState } from './app.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Router, NavigationEnd, NavigationStart } from "@angular/router";
import { EmitService } from './ts/services/emit.service';
import { CommonService } from "@app/shared/common/common.service";
import { environment } from '@env/environment';
import { VersionCheckService } from "@app/shared/versioncheck/version-check.service";
import { filter } from 'rxjs/operators';
import { DialogCleanupService } from './ts/services/dialog-cleanup.service';

declare var $: any;

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,

})
export class AppComponent implements OnInit {
  public title = 'app works!';
  public navIsFixed = false;
  private idleState = 'Not started.';
  private timedOut = false;
  private isIdle: boolean;
  private idleEndCount = 0;
  private idleStartCount = 0;
  private idleTimeoutCount = 0;
  private idleTimeoutWarningCount = 0;
  modalOptions: {};
  msalIntance;
  msalConfig;
  action = '';
  cookieExistValue: any;
  public constructor(private viewContainerRef: ViewContainerRef,
    private idle: Idle,
    private router: Router,
    private emitService: EmitService,
    private commonService: CommonService,
    private appService: AppState,
    private versionCheckService: VersionCheckService,
    private dialogCleanup: DialogCleanupService
  ) {
    this.appService.setLocalStorageFunctions();
    // debugger
    // this.appService.getMetadata().subscribe(response=>{
    //   localStorage.setItem('config',response['DATA'])
    //   console.log(JSON.parse(atob( localStorage.getItem('config'))));

    if (this.commonService.getCookie(environment.loginCookie)) {
      let cookieExist = this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.loginCookie)));
      // let cookieExist = '{"cookieCreatedTime":"2022-06-21T07:07:13.000Z","userMail":"r.murali@iomarket.in","partyID":"179","userID":50,"accId":50,"netcomId":"41420-0000411602-52"}';
      if (cookieExist) {
        let instanceArray = ['hilcona', 'io-market', 'repower'];
        let array = window.location.href.replace(window.location.origin, '').split('/');
        let pathName;
        for (let index = 0; index < instanceArray.length; index++) {
          const element = instanceArray[index];
          if (array.indexOf(element) != -1) {
            array.splice(array.indexOf(element), 1);
            break;
          }
        }
        array = array.filter(function (item) {
          return item !== 'autologin';
        });
        pathName = array.join("/");
        let stateObj = { id: "100" };
        window.history.replaceState(stateObj, "newVersion", pathName);
        this.cookieExistValue = JSON.parse(cookieExist);

        console.log("Cookie data ", this.cookieExistValue);
        // console.log('loginCookie',this.cookieExistValue)
        localStorage.setEncryptedItem('userMail', this.cookieExistValue['userMail']);
        localStorage.setEncryptedItem('loginId', this.cookieExistValue['userId']);
        localStorage.setEncryptedItem('userName', this.cookieExistValue['username']);
        localStorage.setEncryptedItem('firstName', this.cookieExistValue['firstName']);
        localStorage.setEncryptedItem('name', this.cookieExistValue['name']);
        localStorage.setEncryptedItem('companyName', this.cookieExistValue['companyName']);
        localStorage.setEncryptedItem('companyUserId', this.cookieExistValue['companyUserId']);
        localStorage.setEncryptedItem('companyId', this.cookieExistValue['companyId']);
        localStorage.setEncryptedItem('profileImage', this.cookieExistValue['profileImage']);
        localStorage.setEncryptedItem('loggedInTime', this.cookieExistValue['loggedInTime']);
        localStorage.setEncryptedItem('userNumber', this.cookieExistValue['userNumber']);
        // localStorage.setEncryptedItem('userLanguage', this.cookieExistValue['DATA'].LANGUAGE);
        localStorage.setEncryptedItem('appUserId', this.cookieExistValue['instanceUserId']);
        localStorage.setEncryptedItem('department', this.cookieExistValue['department']);
        localStorage.setEncryptedItem('notesVisible', JSON.stringify(false));
      }
    }
    else {
      this.noCookie();
    }
    if (this.commonService.getCookie(environment.instanceCookie)) {
      let insatnceCookieExist = this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.instanceCookie)));

      if (insatnceCookieExist) {
        insatnceCookieExist = JSON.parse(insatnceCookieExist);
        let logoImage = JSON.stringify({
          "whiteTheme": insatnceCookieExist['whiteLogo'],
          "normalLogo": insatnceCookieExist['logo']
        });
        localStorage.setEncryptedItem('instanceId', insatnceCookieExist['instanceId']);
        localStorage.setEncryptedItem('instance', insatnceCookieExist['instance']);
        localStorage.setEncryptedItem('logo', logoImage);

        $('#favIcon').attr('href', environment.NETGATE_URL + 'ngtFiles/netgate05/ngtSysImages/instance/' + localStorage.getEncryptedItem('instance') + '.ico');
        //   let favIcon ={"hilcona":"https://hilcona.com/wp-content/uploads/2021/11/cropped-cropped-210628_hilcona_website_favicon_variant-32x32-1-32x32.png",
        //   "repower":"assets/img/favicon/repower.ico"}
        //   let defaultFavIcon = "assets/img/favicon/favicon.ico";
        //   $('#favIcon').attr('href',favIcon[insatnceCookieExist['instance']] ? favIcon[insatnceCookieExist['instance']] : defaultFavIcon)
      }
    }
    else {
      this.noCookie();
    }
    if (localStorage.getEncryptedItem('loginId') != '' && localStorage.getEncryptedItem('loginId') != null && localStorage.getEncryptedItem('appUserId') != null) {
      this.action = 'Set';
      this.manipulateLoginTime();
    }
    // })            


    this.isIdle = false;

    this.idle.setIdle(86400);
    this.idle.setTimeout(10);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleEndCount++;
      this.idleState = 'No longer idle.';
    });

    idle.onTimeout.subscribe(() => {
      this.idleTimeoutCount++;
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.action = 'Clear';
      if (localStorage.getEncryptedItem('appUserId') != null && localStorage.getEncryptedItem('loginId') != null)
        this.manipulateLoginTime();
      // localStorage.removeEncryptedItem("loginId");
      this.commonService.logout();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleStartCount++;
      this.idleState = 'You\'ve gone idle!';
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleTimeoutWarningCount++;
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });

    this.reset();
    this.initAlertPopup();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((e: NavigationEnd) => {
        this.emitService.emitPreviosUrl(e.url);
      });
    $(window).on('beforeunload', () => {
      let numberOfTabs = parseInt(localStorage.getItem('numberOfTabs'));
      numberOfTabs--;
      localStorage.setItem('numberOfTabs', numberOfTabs.toString());
      if (numberOfTabs == 0 && localStorage.getEncryptedItem('appUserId') != null && localStorage.getEncryptedItem('loginId') != null) {
        this.action = 'Clear';
        this.manipulateLoginTime();
      }
    });

  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (window.innerWidth > 991) {
      let number = $(window).scrollTop();
      if (number > 20) {
        $("body").addClass("fixed");
      } else {
        $("body").removeClass("fixed");
      }
    }
  }

  manipulateLoginTime() {
    var formData = new FormData();
    formData.append("companyId", localStorage.getEncryptedItem('companyId'));
    formData.append('userId', localStorage.getEncryptedItem('loginId'));
    formData.append('appUserId', localStorage.getEncryptedItem('appUserId'));
    formData.append('action', this.action);
    formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    formData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    let objectCount = this.commonService.createObject(formData);
    let tokenCount = this.commonService.createToken(objectCount);
    let encryptedTokenCount = this.commonService.encrypt(tokenCount);
    let encrDataCount = new FormData();
    encrDataCount.append("encrToken", encryptedTokenCount);
    this.appService.clearLoginTime(encrDataCount).subscribe((data: any) => {
      if (!data.status && data.isUnauthenticated) {
        this.commonService.logout();
        return false;
      }
      localStorage.setEncryptedItem("lastRequestTime", data.RESPONSETIME);
    });
  }

  ngOnDestroy() {
    this.idle.stop();
    $("#alertpopup").dialog("destroy");
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  ngOnInit() {
    localStorage.removeEncryptedItem("lastRequestTime");
    localStorage.setItem('logout', JSON.stringify(false));

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.dialogCleanup.destroyAllDialogs();
      }
    });

    if ($?.ui?.dialog) {
      $.ui.dialog.prototype.options.show = {
        effect: "drop", direction: "up", duration: 400
      };

      $.ui.dialog.prototype.options.hide = {
        effect: "drop", direction: "up", duration: 250
      };
    }

    // this.versionCheckService.initVersionCheck('version.json');  
    // this.checkuserRights()
  }

  initAlertPopup() {
    this.modalOptions = {
      autoOpen: false,
      modal: true,
      dialogClass: 'deletegroupmember',
      width: window.innerWidth > 767 ? 500 : 300,
      resizable: false,
      closeText: '',
    };
    $("#alertpopup").dialog(this.modalOptions);
  }

  refresh() {
    // $('#alertpopup').dialog("close");
    // location.reload(true);
  }
  tokenCallBack(errorDesc: string, token: string, error: string, tokenType: string, userState: string) { }

  noCookie() {
    let instanceArray = ['hilcona', 'io-market', 'repower'];
    let array = window.location.href.replace(window.location.origin, '').split('/');
    for (let index = 0; index < instanceArray.length; index++) {
      const element = instanceArray[index];
      if (array.indexOf(element) != -1) {
        localStorage.setEncryptedItem('instance', array[array.indexOf(element)]);
        array.splice(array.indexOf(element), 1);
        let stateObj = { id: "100" };
        let pathName;
        pathName = array.join("/");
        window.history.replaceState(stateObj, "newVersion", pathName);
        break;
      }
    }
    this.commonService.logout();
  }
  // checkuserRights(){
  //   var formData = new FormData();
  //   formData.append("instanceId", localStorage.getEncryptedItem('instanceId'))
  //   formData.append("companyUserId", this.cookieExistValue['companyUserId'])
  //   formData.append('userId',this.cookieExistValue['userId']);
  //   formData.append("loggedInTime", this.cookieExistValue['loggedInTime']);
  //   formData.append("lastRequestTime",localStorage.getEncryptedItem("lastRequestTime"));
  //   let object = this.commonService.createObject(formData)
  //   let token = this.commonService.createToken(object)
  //   let encryptedToken = this.commonService.encrypt(token)
  //   let encrData  = new FormData()
  //   encrData .append("encrToken", encryptedToken);

  //   this.appService.getUserRights(encrData).subscribe(res => {

  //     localStorage.setEncryptedItem("lastRequestTime", res['RESPONSETIME']);
  //     let right = String(res['DATA'])
  //     // console.log('222',right)
  //     // console.log('++++',res['DATA'])
  //     localStorage.setEncryptedItem("userRights", right);
  //     // let userRights = this.commonService.encrypt(right);
  //     // console.log(userRights,'---------------userrightsssssssss-----------------');
  //   })
  // }
}
